import React, { FC } from 'react';
import './LoadingView.css';

interface LoadingViewProps {}

const LoadingView: FC<LoadingViewProps> = () => (
  <div className="LoadingView">
    <div className="plusContainer">
      <div className="plus gray left"></div>
      <div className="plus gray bottom"></div>
      <div className="plus red right"></div>
      <div className="plus red top"></div>
    </div>
  </div>
);

export default LoadingView;
